// all Vue.js initialization
import VMask from 'v-mask'
import { isAndroid } from '../useragent';


// set up event system first
import './events';
import './logged-in-user';

// directives
import './directives/numbersOnly';

// components
import './components/form-progress';
import './components/dialog';
import './components/tooltip';
import './components/recaptcha';

// dev tools turned on in development mode
if (__DEV__) {
  Vue.config.devtools = true;
}

// Our templates will have masking, as long as a user isn't on Android
if (!isAndroid) {
  Vue.use(VMask);
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/index.js